const foodImages = require.context('../../../assets/images/foods', true);

export const getImage = (imageName: string) => {
  try {
    const img = foodImages(`./${imageName}`);
    return img;
  } catch (e) {}
};
